var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncidenciaResuelta = function SvgIncidenciaResuelta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "incidencia_resuelta_svg__Capa_2",
    viewBox: "0 0 50.29 50.29"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "incidencia_resuelta_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.29,
    height: 49.29,
    x: 0.5,
    y: 0.5,
    rx: 8.85,
    ry: 8.85,
    strokeMiterlimit: 10,
    fill: "#ebfffd",
    stroke: "#d4f7f4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.14,
    cy: 25.14,
    r: 12.85,
    fill: "none",
    stroke: "#2ad2c5",
    strokeWidth: "2px",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.89 24.85 3.81 3.81c.08.08.2.08.28 0l7.51-7.51",
    strokeLinecap: "round",
    fill: "none",
    stroke: "#2ad2c5",
    strokeWidth: "2px",
    strokeMiterlimit: 10
  }))));
};
export default SvgIncidenciaResuelta;